/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST + '/clb'
export const getClbProductCategoryTable = params => {
  return axios.post(`${base}/query_product_category`, params)
}
export const getClbProductCategoryDetail = params => {
  return axios.get(`${base}/get_product_category_${params.id}`, {params})
}
// export const exportClbProductCategoryData = params => {
//   return axios.get(`${base}/exportClbProductCategoryData_${params.id}`, {params})
// }
export const createClbProductCategoryData = params => {
  return axios.post(`${base}/create_product_category`, params)
}
export const updateClbProductCategoryData = params => {
  return axios.post(`${base}/modify_product_category_${params.id}`, params)
}
export const deleteClbProductCategoryData = params => {
  return axios.post(`${base}/delete_product_category_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/clb-product-category/clb-product-category.api.js